import request from '@/utils/request'

const getById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-course/${id}`,
    method: 'get'
  })
}

const getByCourseId = (courseId) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-course/course-id/${courseId}`,
    method: 'get'
  })
}

const getMyCoursePageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-course/page-list`,
    method: 'get',
    params: query
  })
}

function subscribeCourse(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-course/subscribe`,
    method: 'post',
    data
  })
}

function unSubscribeCourse(id) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-course/un-subscribe/${id}`,
    method: 'post'
  })
}

export default {
  getById,
  getByCourseId,
  subscribeCourse,
  unSubscribeCourse,
  getMyCoursePageList
}
